import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_SANDBOX, SHOP_BY_BEST_SELLER } from '../../../Constants/Config';

const initialState = {
  loading: false,
  shopByBestSellerList: [],
  error: '',
  totalPages: 0,
  hasMore: true,
};

export const fetchShopByBestSellerLists = createAsyncThunk(
  'shopByBestSellerList/fetchShopByBestSellerLists',
  async ({  lat, long }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

        formData.append('lat', lat || '');
      formData.append('long', long || '');
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${SHOP_BY_BEST_SELLER}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status === 200 && response.data && response.data.data) {
        return {
          shopByBestSellerList: response.data.data,
          totalPages: response?.data?.totalPages,
        };
      } else {
        return { shopByBestSellerList: [], totalPages: 0, hasMore: false };
      }
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

const shopByBestSellerSlice = createSlice({
  name: 'shopByBestSellerList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchShopByBestSellerLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShopByBestSellerLists.fulfilled, (state, action) => {
        state.loading = false;
        state.shopByBestSellerList = action.payload?.shopByBestSellerList;
        state.totalPages = action.payload?.totalPages || 0;
        state.error = '';
      })
      .addCase(fetchShopByBestSellerLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch  Shop by Best Sellers Near You';
        state.hasMore = false;
      });
  },
});

export default shopByBestSellerSlice.reducer;